import { BUREAU_ENUMS } from 'pages/RedesignDashboard/constants';

const { ALL, TRANS_UNION, EXPERIAN, EQUIFAX } = BUREAU_ENUMS;

export const parseTradeline = (tradeline, bureau = ALL) => {
  const parsedTradeline = {
    creditor: tradeline?.creditor,
    dateOpened: tradeline?.dateOpened,
    ageInMonths: tradeline?.tradelineAgeInMonths,
    bureauAgeInMonths: {
      transunion: {
        ageInMonths:
          bureau === TRANS_UNION
            ? tradeline?.tradelineAgeInMonths
            : tradeline?.bureauTradelineAgeInMonths?.transUnion,
      },
      equifax: {
        ageInMonths:
          bureau === EQUIFAX
            ? tradeline?.tradelineAgeInMonths
            : tradeline?.bureauTradelineAgeInMonths?.equifax,
      },
      experian: {
        ageInMonths:
          bureau === EXPERIAN
            ? tradeline?.tradelineAgeInMonths
            : tradeline?.bureauTradelineAgeInMonths?.experian,
      },
    },
  };

  return parsedTradeline;
};
